import React, { useState, useEffect, Fragment, useRef } from "react";
import Breadcrumb from "../../components/common/breadcrumb";
import axiosConfig from "../../services/axiosConfig";
import setHeader from "../../components/Functions/setHeader";
// import OrderStatusModal from "./OrderDetailsPage";
import { BsFillCartXFill } from "react-icons/bs";
import { FaEye } from "react-icons/fa";
import { useNavigate } from "react-router-dom";
import { useDispatch, useSelector } from "react-redux";
import { fetchActiveCurrencies } from "../../redux/ecommerce/currency/actions";

const AllOrders = () => {
  const [data, setData] = useState([]);
  const [loading, setLoading] = useState(false);
  const {currencies} = useSelector(state => state.Currency);
    const dispatch = useDispatch()
    useEffect(() => {
      dispatch(fetchActiveCurrencies()); // must be called
    }, [dispatch]);
  const [showModal, setShowModal] = useState(false);
  const [selectedOrder, setSelectedOrder] = useState(null);
  const [search, setSearch] = useState("");
  const [from_date, setFromDate] = useState("");
  const [to_date, setToDate] = useState("");
  //  const reloaded = useRef(false);
  //   // Reload only once
  //   useEffect(() => {
  //     if (!reloaded.current) {
  //       reloaded.current = true;
  //       window.location.reload();
  //     }
  //   }, []);
  const [status, setStatus] = useState("");
  const [page, setPage] = useState(1);
  const [limit, setLimit] = useState(10);
  const [total, setTotal] = useState(0);

  // Reset page to 1 when filters change
  useEffect(() => {
    setPage(1);
  }, [search, from_date, status, limit]);

  // Debounced search effect
  useEffect(() => {
    const timeoutId = setTimeout(() => {
      getData();
    }, search ? 300 : 0); // 300ms delay for search, immediate for others

    return () => clearTimeout(timeoutId);
  }, [page, limit, search, from_date,to_date, status]);

  // Handle case where current page has no data but there are results on other pages
  useEffect(() => {
    if (!loading && data.length === 0 && total > 0 && page > 1) {
      // If we're on a page > 1 with no data, but there are total results, go to page 1
      setPage(1);
    }
  }, [data, loading, total, page]);

  const getData = () => {
    setLoading(true);

    const params = {
      search: search.trim() || undefined,
      from_date: from_date || undefined,
      to_date: to_date || undefined,
      status: status || undefined,
      limit,
      page,
    };

    axiosConfig.get("orders-list", { params, ...setHeader() })
      .then((res) => {
        const responseData = res.data.data || [];
        setData(responseData);
        setTotal(res.data.total || 0);
      })
      .catch((error) => {
        console.error("Error fetching data:", error);
        setData([]);
        setTotal(0);
      })
      .finally(() => {
        setLoading(false);
      });
  };

  // Function to get status text based on status code
  const getStatusText = (statusCode) => {
    const statusMap = {
      0: "Pending",
      1: "Accepted",
      2: "Dispatch",
      3: "Shipped",
      4: "Delivered",
      5: "Rejected",
      6: "Return",
      7: "User Canceled"
    };
    return statusMap[statusCode] || "Unknown";
  };

  // Function to get status badge class based on status code
  const getStatusBadgeClass = (statusCode) => {
    const statusClasses = {
      0: "badge bg-warning text-dark", // Pending - Yellow
      1: "badge bg-success", // Accepted - Green
      2: "badge bg-info", // Dispatch - Blue
      3: "badge bg-primary", // Shipped - Blue
      4: "badge bg-success", // Delivered - Green
      5: "badge bg-danger", // Rejected - Red
      6: "badge bg-secondary", // Return - Gray
      7: "badge bg-dark" // User Canceled - Dark
    };
    return statusClasses[statusCode] || "badge bg-light text-dark";
  };
  const navigate = useNavigate()
  // Handle change status button click
const handleViewOrder = (order) => {
  navigate("/pages/order-details", { state: { selectedOrder: order } });
};
  // Handle modal close

  // Handle status update success - refresh data
 
  // Pagination calculations
  const totalPages = search || status
    ? Math.ceil(data.length / limit) // use filtered data count
    : Math.ceil(total / limit);      // use total for normal view


  const currentData = data; // API already paginated


  const handleClearFilters = () => {
    setSearch("");
    setFromDate("");
    setToDate("");
    setStatus("");
    setPage(1);   // reset to first page
    getData();    // reload data without filters
  };


  // Handle items per page change
  const handleItemsPerPageChange = (e) => {
    setLimit(parseInt(e.target.value));
    setPage(1); // reset to first page
  };

  // Calculate the starting index for current page
  const getStartingIndex = () => {
    return (page - 1) * limit;
  };

  // Calculate showing range
  const getShowingRange = () => {
    const start = getStartingIndex() + 1;
    const end = Math.min(page * limit, total);
    return { start, end };
  };

  return (
    <Fragment>
      <Breadcrumb title="All Orders" parent="Orders" />
      <div className="container-fluid">
        <div className="d-flex gap-3 mb-3">
          {/* Search by Order ID */}
          <input
            type="text"
            className="form-control"
            placeholder="Search"
            value={search}
            onChange={(e) => setSearch(e.target.value)}
            style={{ maxWidth: "200px" }}
          />

          {/* Filter by Date */}
          <input
            type="date"
            className="form-control"
            value={from_date}
            onChange={(e) => setFromDate(e.target.value)}
            style={{ maxWidth: "200px" }}
          />
          <input
            type="date"
            className="form-control"
            value={to_date}
            onChange={(e) => setToDate(e.target.value)}
            style={{ maxWidth: "200px" }}
          />

          {/* Filter by Status */}
          <select
            className="form-select"
            value={status}
            onChange={(e) => setStatus(e.target.value)}
            style={{ maxWidth: "200px" }}
          >
            <option value="">All Status</option>
            <option value="0">Pending</option>
            <option value="1">Accepted</option>
            <option value="2">Dispatch</option>
            <option value="3">Shipped</option>
            <option value="4">Delivered</option>
            <option value="5">Rejected</option>
            <option value="6">Return</option>
            <option value="7">User Canceled</option>
          </select>

          {/* Clear Filters Button */}
          <button
            className="btn btn-primary"
            onClick={handleClearFilters}
          >
            Clear Filters
          </button>
        </div>

        <div className="row">
          <div className="col-sm-12">
            <div className="card">
              <div className="card-header">
                <h5>Orders List</h5>
              </div>
              <div className="card-body">
                {/* Pagination controls at top */}
                <div className="d-flex justify-content-between align-items-center mb-3">
                  <div className="d-flex align-items-center">
                    <span className="me-2">Show</span>
                    <select
                      className="form-select form-select-sm"
                      style={{ width: 'auto' }}
                      value={limit}
                      onChange={handleItemsPerPageChange}
                    >
                      <option value={10}>10</option>
                      <option value={25}>25</option>
                      <option value={50}>50</option>
                      <option value={100}>100</option>
                    </select>
                    <span className="ms-2">entries</span>
                  </div>
                  <div className="text-muted">
                    {total > 0 ? (
                      <>Showing {getShowingRange().start} to {getShowingRange().end} of {total} entries</>
                    ) : (
                      <>No entries found</>
                    )}
                  </div>
                </div>

                {/* Modified table container with horizontal scroll */}
                <div className="table-responsive" style={{ overflowX: 'auto' }}>
                  <table className="table table-striped table-hover" style={{ minWidth: '1200px' }}>
                    <thead>
                      <tr>
                        <th scope="col" style={{ minWidth: '50px' }}>#</th>
                        <th scope="col" style={{ minWidth: '120px' }}>Order ID</th>
                        <th scope="col" style={{ minWidth: '120px' }}>Date</th>
                        <th scope="col" style={{ minWidth: '120px' }}>Product Code</th>
                        <th scope="col" style={{ minWidth: '200px' }}>Product Name</th>
                        <th scope="col" style={{ minWidth: '80px' }}>Qty</th>
                        <th scope="col" style={{ minWidth: '220px' }}>Customer</th>
                        <th scope="col" style={{ minWidth: '100px' }}>Status</th>
                        <th scope="col" style={{ minWidth: '100px' }}>Total</th>
                        <th scope="col" style={{ minWidth: '240px' }}>Action</th>
                      </tr>
                    </thead>
                    <tbody>
                      {loading ? (
                        // Show loading spinner/message
                        <tr>
                          <td colSpan="10" className="text-center py-4">
                            <div className="text-muted">
                              <div className="spinner-border text-primary" role="status">
                                <span className="visually-hidden">Loading...</span>
                              </div>
                              <p>Loading orders...</p>
                            </div>
                          </td>
                        </tr>
                      ) : currentData.length > 0 ? (
                        currentData.map((item, index) => {
                          const serialNumber = getStartingIndex() + index + 1;

                          return (
                            <tr key={`${item.order_id}-${item.id}-${index}`}>
                              <th scope="row" style={{ fontWeight: 'bold', color: '#007bff' }}>
                                {serialNumber}
                              </th>
                              <td>
                                <span className="fw-bold text-primary">
                                  #{item.order_id}
                                </span>
                              </td>
                              <td>
                                {new Date(item.order_date).toLocaleDateString('en-GB', {
                                  day: '2-digit',
                                  month: '2-digit',
                                  year: '2-digit',
                                })}
                              </td>
                              <td>{item.productCode}</td>
                              <td>
                                <div
                                  style={{
                                    maxWidth: '200px',
                                    whiteSpace: 'nowrap',
                                    overflow: 'hidden',
                                    textOverflow: 'ellipsis',
                                  }}
                                  title={item.productName}
                                >
                                  {item.productName}
                                </div>
                              </td>
                              <td>{item.qty}</td>
                              <td>{item.name || item.username}</td>
                              <td>
                                <span className={getStatusBadgeClass(item.order_status)}>
                                  {getStatusText(item.order_status)}
                                </span>
                              </td>
                              <td>
                                <span className="fw-bold">{currencies?.symbol} {item.amount}</span>
                              </td>
                              <td>
                                <button
                                  className="btn btn-primary btn-sm"
                                  onClick={() => handleViewOrder(item)}
                                  title="Change Order Status"
                                  style={{ display: 'flex', alignItems: 'center', gap: '.5rem' }}
                                // disabled={
                                //   item.order_status === '4' ||  // Delivered
                                //   item.order_status === '7' ||  // User Canceled
                                //   item.order_status === '5'     // Rejected
                                // }
                                >
                                  <FaEye />
                                  View
                                </button>
                              </td>
                            </tr>
                          );
                        })
                      ) : (
                        // Show "No orders found" message
                        <tr>
                          <td colSpan="10" className="text-center py-4">
                            <div className="text-muted">
                              <BsFillCartXFill style={{ fontSize: '4rem' }} />
                              <p>No orders found</p>
                            </div>
                          </td>
                        </tr>
                      )}
                    </tbody>
                  </table>
                </div>

                {/* Pagination - show if there are results OR if we're not on page 1 */}
                {total > limit && totalPages > 1 && (
                  <div style={{ display: 'flex', justifyContent: 'end' }}>
                    <ul className="pagination flex-center flex-wrap gap-16" style={{ marginTop: '20px' }}>
                      {/* Previous Button */}
                      <li className="page-item">
                        <button
                          className="page-link h-64 w-64 flex-center text-xxl rounded-8 fw-medium text-neutral-600 border border-gray-100"
                          disabled={page === 1}
                          onClick={() => setPage(page - 1)}
                        >
                          Previous
                        </button>
                      </li>

                      {/* Page numbers with ellipsis */}
                      {Array.from({ length: totalPages }, (_, i) => i + 1)
                        .filter(
                          (p) =>
                            p === 1 ||
                            p === totalPages ||
                            Math.abs(p - page) <= 1 // show current and neighbors
                        )
                        .map((p, idx, arr) => (
                          <React.Fragment key={p}>
                            {idx > 0 && p - arr[idx - 1] > 1 && (
                              <li className="page-item disabled">
                                <span className="page-link h-64 w-64 flex-center">...</span>
                              </li>
                            )}
                            <li className="page-item">
                              <button
                                className={`page-link h-64 w-64 flex-center text-md rounded-8 fw-bold border border-gray-100 ${page === p
                                  ? "bg-primary text-white border-primary" // Active style
                                  : "text-neutral-600 hover:bg-gray-100"
                                  }`}
                                onClick={() => setPage(p)}
                              >
                                {p}
                              </button>
                            </li>
                          </React.Fragment>
                        ))}

                      {/* Next Button */}
                      <li className="page-item">
                        <button
                          className="page-link h-64 w-64 flex-center text-xxl rounded-8 fw-medium text-neutral-600 border border-gray-100"
                          onClick={() => setPage(page + 1)}
                          disabled={page === totalPages}
                        >
                          Next
                        </button>
                      </li>
                    </ul>
                  </div>
                )}


              </div>
            </div>
          </div>
        </div>
      </div>

      {/* Order Status Modal */}
      {/* <OrderStatusModal
        show={showModal}
        onHide={handleModalClose}
        order={selectedOrder}
        onStatusUpdate={handleStatusUpdate}
      /> */}
    </Fragment>
  );
};

export default AllOrders;